var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("数据查询")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("仓库数据")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "query" },
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-demo",
              attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
              on: { select: _vm.handleSelect },
            },
            _vm._l(_vm.wareData, function (item, index) {
              return _c(
                "el-menu-item",
                { key: index, attrs: { index: item.name } },
                [_vm._v(_vm._s(item.name))]
              )
            }),
            1
          ),
          _c("div", { staticClass: "title" }, [
            _c(
              "span",
              {
                staticClass: "queryCommodity",
                style: { color: _vm.selectQuery === 2 ? "#666" : "#2d7edf" },
                on: {
                  click: function ($event) {
                    return _vm.selectQueryClick(1)
                  },
                },
              },
              [_vm._v("查询商品")]
            ),
            _c(
              "span",
              {
                staticClass: "queryGift",
                style: { color: _vm.selectQuery === 1 ? "#666" : "#2d7edf" },
                on: {
                  click: function ($event) {
                    return _vm.selectQueryClick(2)
                  },
                },
              },
              [_vm._v("查询赠品")]
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.queryForm, "label-width": "80px" },
            },
            [
              _c(
                "el-form-item",
                { staticClass: "formItem", attrs: { label: "产品名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入产品名称" },
                    model: {
                      value: _vm.queryForm.info,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryForm, "info", $$v)
                      },
                      expression: "queryForm.info",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "formItem", attrs: { label: "选择品牌" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择品牌" },
                      model: {
                        value: _vm.queryForm.service,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "service", $$v)
                        },
                        expression: "queryForm.service",
                      },
                    },
                    _vm._l(_vm.brand, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "formItem", attrs: { label: "商品厂家" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入商品厂家" },
                    model: {
                      value: _vm.queryForm.vender,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryForm, "vender", $$v)
                      },
                      expression: "queryForm.vender",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "formItem", attrs: { label: "时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      size: "mini",
                      clearable: "",
                      type: "daterange",
                      "value-format": "yyyy-MM-dd",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    model: {
                      value: _vm.queryForm.date,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryForm, "date", $$v)
                      },
                      expression: "queryForm.date",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("搜索商品")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { size: "mini", type: "warning" },
                  on: { click: _vm.onReset },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "total" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "left" }, [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [_vm._v("仓库数据")]),
                  ]),
                  _c("div", { staticClass: "context" }, [
                    _c("div", { staticClass: "border" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "red",
                            "font-size": "18px",
                            "font-weight": "500",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.tableData.stocks ? _vm.tableData.stocks : 0
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("span", [_vm._v("仓库总库存")]),
                    ]),
                    _c("div", { staticClass: "border" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "red",
                            "font-size": "18px",
                            "font-weight": "500",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.tableData.outStocks
                                  ? _vm.tableData.outStocks
                                  : 0
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("span", [_vm._v("仓库出库数据")]),
                    ]),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 18 } }, [
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("品牌数据")]),
                  _c(
                    "div",
                    { staticClass: "context" },
                    _vm._l(_vm.tableData.brand, function (item) {
                      return _c("div", { staticClass: "border" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "red",
                              "font-size": "18px",
                              "font-weight": "500",
                            },
                          },
                          [_vm._v(" " + _vm._s(item.number) + " ")]
                        ),
                        _c("span", [_vm._v(_vm._s(item.name))]),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.tableData.commoditys
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                "header-cell-style": { color: "#2E7EDF" },
                data: _vm.tableData.commoditys.list,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "商品图片", width: "180" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-image", {
                            staticStyle: { width: "100px", height: "100px" },
                            attrs: {
                              src: _vm.img(scope.row.image),
                              fit: "cover",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2107310855
                ),
              }),
              _c("el-table-column", {
                attrs: { prop: "title", label: "商品名称", width: "228" },
              }),
              _c("el-table-column", {
                attrs: { prop: "brandId", label: "商品品牌", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sellPrice", label: "商品单价", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "ranking", label: "出库排行", width: "180" },
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "number",
                  label: "出库总数",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "price", label: "出库总额", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "quantityStock", label: "库存", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "220" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.parArray.indexOf("wareFixCode") != -1
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateDetail(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("修改")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.queryDetail(scope.row.id)
                                },
                              },
                            },
                            [_vm._v("查看详细")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1496034547
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            "append-to-body": true,
            title: "调整仓库",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品名称" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "仓库数量" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      placeholder: "请输入仓库数量",
                      max: _vm.form.quantityStockTemp,
                    },
                    model: {
                      value: _vm.form.quantityStock,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "quantityStock", $$v)
                      },
                      expression: "form.quantityStock",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addStorage },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage1,
                "page-size": _vm.selectSizePage,
                layout: "total,sizes,prev, pager, next",
                "prev-text": "上一页",
                "next-text": "下一页",
                total: !_vm.tableData.commoditys
                  ? 0
                  : _vm.tableData.commoditys.totalNum,
              },
              on: {
                "current-change": _vm.handleCurrentChange,
                "size-change": _vm.handleSizeChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticStyle: { height: "50px" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }